<template>
  <div>
    <h2 class="view-title">
      FAQ
    </h2>
  </div>
</template>

<script>


export default{
  name: 'FaqView'
};
</script>
<style scoped>


</style>